import {
  differenceInHours,
  differenceInMinutes,
  isAfter,
  isToday,
  setHours,
  setMinutes,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export function isInterviewLateCancellation({
  interviewStart,
  interviewCreatedAt,
  hiringReliability,
  isSchedulingPastWorkplaceStartHour,
}: {
  interviewStart: Date;
  interviewCreatedAt: string;
  isSchedulingPastWorkplaceStartHour: boolean;
  hiringReliability: {
    simplifiedBanEnabled: boolean;
    workplaceStartHour: number;
    maxLateCancellationHours: number;
    graceWindowInMinutes: number;
  };
}) {
  const isWithinLateCancelGraceWindow =
    differenceInMinutes(Date.now(), new Date(interviewCreatedAt).getTime()) <
    hiringReliability.graceWindowInMinutes;

  if (isWithinLateCancelGraceWindow) {
    return false;
  }

  if (hiringReliability.simplifiedBanEnabled) {
    return isAfter(new Date(), interviewStart) || isSchedulingPastWorkplaceStartHour;
  }

  return isAfter(interviewStart, new Date())
    ? differenceInHours(interviewStart, new Date()) <= hiringReliability.maxLateCancellationHours
    : false;
}

export function getInterviewAvailability({
  interviewAvailability,
  workerTimezone,
  workplaceTimezone,
  isRescheduleForToday,
}: {
  interviewAvailability: Array<{
    start: Date;
    end: Date;
    eventType: "open-house" | "interview-days" | undefined;
  }>;
  workerTimezone: string;
  workplaceTimezone: string;
  isRescheduleForToday: boolean;
}) {
  if (isRescheduleForToday) {
    return interviewAvailability.filter((timeslot) => {
      const { start, end } = timeslot;
      const workplaceStart = utcToZonedTime(
        zonedTimeToUtc(start, workerTimezone),
        workplaceTimezone
      );
      const workplaceEnd = utcToZonedTime(zonedTimeToUtc(end, workerTimezone), workplaceTimezone);
      return isToday(workplaceStart) && isToday(workplaceEnd);
    });
  }

  return interviewAvailability;
}

export function getWorkplaceStartHour({
  interviewStart,
  workplaceTimezone,
  workerTimezone,
  startHour,
}: {
  interviewStart?: Date | undefined;
  workplaceTimezone: string;
  workerTimezone: string;
  startHour: number;
}) {
  return utcToZonedTime(
    zonedTimeToUtc(
      setMinutes(
        setHours(utcToZonedTime(interviewStart ?? new Date(), workplaceTimezone), startHour),
        0
      ),
      workplaceTimezone
    ),
    workerTimezone
  );
}
